import { useEffect } from "react";

const SUFFIX = "PZRM Buchungssystem";
const DEFAULT_TITLE = SUFFIX;

export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    const prev = document.title;
    const trimmed = (title ?? "").trim();
    document.title = trimmed ? `${trimmed} · ${SUFFIX}` : DEFAULT_TITLE;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
